import { Select, Tooltip } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { getFoerderregimeLabel } from "../../../../components/Paragraph6/utils/getFoerderregimeLabel";
import { FoerderRegime } from "../../../../types/api.types";
import type {
  ExpressOnboardingEegColumnProps,
  ExpressOnboardingGenerator
} from "../../ExpressOnboarding.types";
import { useExpressOnboardingEegSave } from "../hooks/useExpressOnboardingEegSave";

const FOERDERREGIME_OPTIONS = Object.values(FoerderRegime).map(
  (foerderRegime) => ({
    value: foerderRegime,
    label: getFoerderregimeLabel(foerderRegime)
  })
);

function getExpressOnboardingTableFoerderregimeColumn({
  getError,
  setError,
  getDraft,
  updateDraft,
  clearDraft,
  clearError
}: ExpressOnboardingEegColumnProps): MRT_ColumnDef<ExpressOnboardingGenerator> {
  return {
    id: "foerderregime",
    accessorKey: "foerderregime",
    header: "Förderregime",
    enableGlobalFilter: false,
    size: 220,
    Cell: ({ cell, row }) => {
      const value =
        cell.getValue<ExpressOnboardingGenerator["foerderregime"]>();
      const rowDraft = getDraft(row.original.id);
      const currentValue =
        rowDraft && "foerderregime" in rowDraft
          ? (rowDraft.foerderregime ?? null)
          : value;

      const { save, rowIsSaving } = useExpressOnboardingEegSave(row.original, {
        getError,
        setError,
        getDraft,
        updateDraft,
        clearDraft,
        clearError
      });

      const cantEditReason = row.original.uneditable_fields?.foerderregime;

      return (
        <Tooltip disabled={!cantEditReason} label={cantEditReason}>
          <Select
            data={FOERDERREGIME_OPTIONS}
            disabled={!!cantEditReason || rowIsSaving}
            error={getError(row.original.id, "foerderregime")}
            loading={rowIsSaving}
            value={currentValue}
            onChange={(newValue) => {
              const hasChange = newValue !== currentValue;
              if (!hasChange) {
                return;
              }

              const patch = {
                foerderregime: newValue as FoerderRegime | null
              };
              updateDraft(row.original.id, patch);
              save(patch);
            }}
          />
        </Tooltip>
      );
    }
  };
}

export { getExpressOnboardingTableFoerderregimeColumn };
